import AssignmentLateOutlinedIcon from "@mui/icons-material/AssignmentLateOutlined";
import { useLoginContext } from "../Contexts/LoginContext";
import { CircularProgress } from "@mui/material";
import Button from "./Button";

const NewAlertModal = () => {
  const { isLoading, handleAccept, handleSignOut, isTermsID, isConsentID } =
    useLoginContext();

  return (
    <div
      style={{ top: 0, left: 0, bottom: 0, right: 0 }}
      className="min-h-screen max-w-screen flex fixed bg-black bg-opacity-20 backdrop-blur-md z-50"
    >
      <div className="sm:w-89.5 w-72 bg-white m-auto rounded-2xl p-6">
        <div className="grid grid-cols-1 divide-y">
          <div className="w-full flex justify-center">
            <div className="flex items-center justify-center">
              <div className="flex flex-col">
                <div className="flex items-start justify-center">
                  <AssignmentLateOutlinedIcon
                    sx={{
                      fontSize: "50px",
                      color: "#880808",
                    }}
                  />
                </div>
                <div className="w-full text-center text-lg font-bold mt-2">
                  We've updated our{" "}
                  {isTermsID !== "" ? "Terms & Conditions" : ""}
                  {isTermsID !== "" && isConsentID !== "" ? " and " : ""}
                  {isConsentID !== "" ? "Member Consent" : ""}
                </div>
                <div className="text-center mt-2">
                  <div className="text-center">
                    By clicking "Agree" below, you acknowledge that you accept
                    our{" "}
                    <span className="text-[#0947AB] font-bold cursor-pointer">
                      Terms & Conditions
                    </span>{" "}
                    and{" "}
                    <span className="text-[#0947AB] font-bold cursor-pointer">
                      Member Consent
                    </span>
                    {/* */}. Feel free to check our policies anytime for more
                    information.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-row sm:mt-2">
          <Button
            className={`w-full h-10 rounded-xl font-semibold mt-2 text-white transition ease-in-out delay-75 hover:scale-105 ${
              isLoading ? "bg-[#F6F7F7]" : "bg-[#0947AB]"
            }`}
            onClick={handleAccept}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={"1rem"} /> : "Accept"}
          </Button>
          <Button
            className="w-full h-10 rounded-xl font-semibold mt-2 bg-white text-[#0947AB] border-2 border-[#0947AB] transition ease-in-out delay-75 hover:scale-105 ml-2"
            onClick={handleSignOut}
          >
            Decline
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NewAlertModal;
